import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { TemplateService } from '../../../services/template.service';
import { CALENDAR_LOCALE, CUSTOMER_TYPES, PURPOSES, RD_DOC_TYPE } from '../../../services/constant';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import * as validate from 'validate.js';
import * as _ from 'lodash';
import { Number2textThService } from '../../../services/number2text-th.service';
import { API_CONSTANT } from '../../../services/api.constant';
import { HttpClient } from '@angular/common/http';
var DocumentIssueComponent = (function () {
    function DocumentIssueComponent(apiService, modalService, template, number2text_th, router, route, http) {
        var _this = this;
        this.apiService = apiService;
        this.modalService = modalService;
        this.template = template;
        this.number2text_th = number2text_th;
        this.router = router;
        this.route = route;
        this.http = http;
        this.username = localStorage.getItem('username');
        this.step = 1;
        this.isLoading = false;
        this.isSending = false;
        this.errors = {
            document: null,
            buyer: null,
            items: [],
            pdf: null,
            email: null,
        };
        this.rd_doc_types = RD_DOC_TYPE;
        this.customerTypes = CUSTOMER_TYPES;
        this.documentTypes = this.template.get();
        this.clickPrint = false;
        this.clickSentEmail = false;
        this.vatList = [
            { label: 'Non-Vat', value: 'non-vat' },
            { label: 'Vat 0%', value: '0' },
            { label: 'Vat 7%', value: '7' }
        ];
        this.selectedCustomerType = this.customerTypes[0];
        this.today = new Date();
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.data = {
            buyer: {
                receivedFrom: null,
                branchName: '',
                headOffice: false,
                address: '',
                postCode: '',
                country: null,
                taxID: null,
                branchCode: [],
                email: null,
                customerID: null,
                brokerName: null,
                brokerEmail: null,
                typeOfTreaty: null,
            },
            date: null,
            due_date: null,
            documentNo: '',
            companyReferenceDocument: '',
            replaced: false,
            purpose: null,
            purposeText: null,
            referenceDocumentID: [{
                    refDocID: '',
                    refDate: null
                }],
            items: [{
                    po: null,
                    product_id: null,
                    description: '',
                    qty: '1',
                    unitPrice: '0.00',
                    discount: '0.00',
                    amount: 0,
                    rawAmount: 0,
                }],
            vatType: '7',
            payment: {
                type: 'cash',
                cashInfo: '',
                bankInfo: '',
                chequeInfo: '',
                chequeBank: '',
                creditInfo: '',
                creditExpire: ''
            },
            remarks: {
                messages: [null],
            },
        };
        this.remarkCount = [0];
        this.duplicateDocumentNumber = false;
        this.duplicateDocumentNumberText = null;
        this.twoNumberDocumentNumberText = null;
        this.selectedBroker = null;
        this.constraints = {
            buyer: {
                general: {
                    receivedFrom: function (value, attributes, attributeName, options, constraints) {
                        if (value == null || typeof value === 'string' || value instanceof String) {
                            return {
                                presence: { allowEmpty: false }
                            };
                        }
                        return null;
                    },
                    'receivedFrom.name': function (value, attributes, attributeName, options, constraints) {
                        var parentData = attributes.receivedFrom;
                        if (parentData != null && typeof parentData !== 'string' && !(parentData instanceof String)) {
                            return {
                                presence: {
                                    allowEmpty: false,
                                    message: '^Received from can\'t be blank'
                                }
                            };
                        }
                        return null;
                    },
                    address: {
                        presence: { allowEmpty: false }
                    },
                    postCode: function (value, attributes) {
                        if (attributes.country === 'TH') {
                            return {
                                presence: {
                                    allowEmpty: false,
                                    message: '^Postal Code cannot be blank if Country is Thailand'
                                }
                            };
                        }
                        else {
                            return {
                                presence: { allowEmpty: true }
                            };
                        }
                    },
                },
                foreign: {
                    country: {
                        presence: true
                    },
                },
                domestic: {
                    headOffice: {
                        presence: { allowEmpty: false }
                    },
                    branchName: function (value, attributes, attributeName, options, constraints) {
                        if (attributes.headOffice === false) {
                            return {
                                presence: { allowEmpty: true }
                            };
                        }
                        return null;
                    },
                    branchCode: {
                        presence: true
                    },
                },
                notForeign: {}
            },
            document: {
                date: {
                    presence: true
                },
                due_date: function (value, attributes, attributeName, options, constraints) {
                    if (_this.selectedDocumentType && _this.selectedDocumentType.type === 'invoice') {
                        return {
                            presence: { allowEmpty: false }
                        };
                    }
                    return null;
                },
                documentNo: {
                    presence: { allowEmpty: false }
                },
                replaced: {
                    presence: true
                },
                purpose: function (value, attributes, attributeName, options, constraints) {
                    if (attributes.replaced) {
                        return {
                            presence: true
                        };
                    }
                    return null;
                },
                purposeText: function (value, attributes, attributeName, options, constraints) {
                    if (attributes.purpose === 'other') {
                        return {
                            presence: { allowEmpty: false }
                        };
                    }
                    return null;
                }
            },
            referenceDocumentID: function () {
                if (_this.selectedDocumentType && (_this.selectedDocumentType.type === 'credit_note' || _this.selectedDocumentType.type === 'debit_note')) {
                    return {
                        refDocID: {
                            presence: { allowEmpty: false }
                        },
                        refDate: {
                            presence: { allowEmpty: false }
                        }
                    };
                }
                return null;
            },
            item: {
                description: {
                    presence: { allowEmpty: false }
                },
                qty: {
                    presence: true,
                    numericality: {
                        onlyInteger: true,
                        greaterThan: 0
                    }
                },
                unitPrice: {
                    presence: true,
                }
            },
            email: {
                presence: true,
                email: true
            }
        };
        this.result = {
            pdf: null,
            email: null,
            id: null,
            message: null
        };
        this.originalAmount = 0;
        this.originalVat = 0;
        // differenceAmount = 0;
        this.newAmount = 0;
    }
    DocumentIssueComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.resetData();
        this.apiService.getNewBuyer().subscribe(function (res) {
            _this.newBuyerList = res;
        });
        this.setMinDate();
        this.loadData();
        this.getParams();
    };
    DocumentIssueComponent.prototype.selectReceivedFrom = function (receivedFrom) {
        if (this.newBuyerList.includes(receivedFrom)) {
            this.selectNewBuyer(receivedFrom);
        }
        else {
            if (typeof receivedFrom === 'string') {
                this.data.buyer.receivedFrom = receivedFrom;
            }
            else {
                this.data.buyer.receivedFrom = receivedFrom ? receivedFrom.name : null;
            }
            this.branchCodeList = [];
        }
    };
    DocumentIssueComponent.prototype.selectTaxID = function (taxID) {
        if (this.newBuyerList.includes(taxID)) {
            this.selectNewBuyer(taxID);
        }
        else {
            if (typeof taxID === 'string') {
                this.data.buyer.taxID = taxID;
            }
            else {
                this.data.buyer.taxID = taxID ? taxID.tax_id : null;
            }
            this.branchCodeList = [];
        }
    };
    DocumentIssueComponent.prototype.selectNewBuyer = function (buyer) {
        Object.assign(this.data.buyer, {
            receivedFrom: buyer.name,
            taxID: buyer.tax_id,
        });
        this.branchCodeList = buyer.branch;
    };
    DocumentIssueComponent.prototype.selectBranchCode = function (branch) {
        if (branch.id) {
            Object.assign(this.data.buyer, {
                customerID: branch.customer_id,
                address: branch.address,
                postCode: branch.post_code,
                country: branch.country_code,
                branchCode: branch.branch_code,
                email: branch.email,
            });
        }
        else {
            if (branch.branch_code) {
                this.data.buyer.branchCode = branch.branch_code;
            }
            else {
                this.data.buyer.branchCode = branch;
            }
        }
    };
    DocumentIssueComponent.prototype.convertBase64ToUTF8 = function (str) {
        // replace (._-) -> (+/=)
        str = str.replace(/\s/g, '');
        str = str.split('.').join('+');
        str = str.split('_').join('/');
        str = str.split('-').join('=');
        // return decodeURIComponent(encodeURIComponent(window.atob(str)));
        return decodeURIComponent(atob(str).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    };
    DocumentIssueComponent.prototype.getParams = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            // from customer page
            if (params['buyer_branch']) {
                _this.loadBuyerBranch(params['buyer_branch']);
            }
        });
        this.route.queryParams.subscribe(function (params) {
            // from card reader
            if (params['type']) {
                _this.setCustomerType(params['type']);
            }
            if (params['data']) {
                _this.loadDataFromParams(params['data']);
            }
        });
    };
    Object.defineProperty(DocumentIssueComponent.prototype, "total", {
        get: function () {
            var total = 0;
            this.data.items.forEach(function (obj) {
                total += obj.rawAmount;
            });
            return total;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentIssueComponent.prototype, "subTotal", {
        get: function () {
            return this.data.items.map(function (obj) { return Number(obj.amount); }).reduce(function (a, b) { return a + b; }, 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentIssueComponent.prototype, "discountTotal", {
        get: function () {
            return this.data.items.reduce(function (prev, curr) { return Number(prev) + Number(curr.discount); }, 0);
        },
        enumerable: true,
        configurable: true
    });
    DocumentIssueComponent.prototype.sendEmailETaxInvoice = function (data) {
        return this.http.post(API_CONSTANT.send_email_document_issue, data);
    };
    Object.defineProperty(DocumentIssueComponent.prototype, "grandTotalText", {
        get: function () {
            return this.number2text_th.currencyFormat_Baht(this.grandTotal);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentIssueComponent.prototype, "vat", {
        get: function () {
            return this.subTotal * (this.data.vatType === 'non-vat' ? 0 : Number(this.data.vatType)) / 100.0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentIssueComponent.prototype, "grandTotal", {
        get: function () {
            return this.subTotal + this.vat;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentIssueComponent.prototype, "isForeignCorporation", {
        // get grandTotalText() {
        //   return this.number2text_th.currencyFormat_Baht(this.grandTotal);
        // }
        get: function () {
            return this.selectedCustomerType.type === 'foreign_corporation';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentIssueComponent.prototype, "isDomesticCorporation", {
        get: function () {
            return ['thailand_corporation', 'affiliated_corporation'].indexOf(this.selectedCustomerType.type) !== -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentIssueComponent.prototype, "getNewAmount", {
        get: function () {
            var originalAmountNumber = +this.originalAmount;
            if (this.selectedDocumentType.type === 'debit_note') {
                return originalAmountNumber + this.subTotal;
            }
            else if (this.selectedDocumentType.type === 'credit_note') {
                return originalAmountNumber - this.subTotal;
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    DocumentIssueComponent.prototype.getStringValue = function (value, key) {
        var isString = (typeof value === 'string' || value instanceof String);
        return isString ? value : value[key];
    };
    DocumentIssueComponent.prototype.havePermissionForDocumentType = function (allowedRoles) {
        return (allowedRoles.indexOf(localStorage.getItem('group')) > -1);
    };
    DocumentIssueComponent.prototype.loadData = function () {
        this.loadCountry();
    };
    DocumentIssueComponent.prototype.loadCountry = function () {
        var _this = this;
        this.apiService.getCountry().subscribe(function (res) {
            _this.countryList = res.map(function (obj) { return ({
                label: obj.country_name,
                value: obj.country_code
            }); });
        });
    };
    DocumentIssueComponent.prototype.loadBuyerBranch = function (id) {
        var _this = this;
        this.apiService.getBuyerBranchData(id).subscribe(function (res) {
            // set buyer info
            _this.data.buyer.receivedFrom = res;
            _this.selectBuyer(res, true);
            // set customer type
            _this.customerTypes.forEach(function (obj) {
                if (obj.value === res.buyer_type) {
                    _this.selectedCustomerType = obj;
                }
            });
            // skip to document type selection
            _this.step = 1;
        }, function (err) {
        });
    };
    DocumentIssueComponent.prototype.loadDataFromParams = function (data) {
        if (data == null) {
            return;
        }
        var parsedData = JSON.parse(this.convertBase64ToUTF8(data));
        this.data.buyer.receivedFrom = { name: parsedData['name'] };
        this.data.buyer.address = parsedData['address'];
        this.data.buyer.taxID = { tax_id: parsedData['id'] };
    };
    DocumentIssueComponent.prototype.setCustomerType = function (type) {
        var _this = this;
        this.customerTypes.forEach(function (obj) {
            if (obj.type === type) {
                _this.selectCustomerType(obj);
            }
        });
    };
    // completeBuyerList(event, isName) {
    //   const query = event.query;
    //   const params = {
    //     buyer_type: this.selectedCustomerType.value
    //   };
    //   if (isName) {
    //     params['name'] = query;
    //   } else {
    //     params['tax_id'] = query;
    //   }
    //   this.apiService.getBuyer(params).subscribe(
    //     (res: any) => {
    //       this.buyerList = res;
    //       }
    //   );
    // }
    DocumentIssueComponent.prototype.completeInvoiceNo = function (event, isName) {
        var _this = this;
        var query = event.query;
        var params = {
            header_invoice_number: this.data.referenceDocumentID
        };
        if (isName) {
            params['header_invoice_number'] = query;
        }
        else {
            params['id'] = query;
        }
        this.apiService.getInvoiceNo(params).subscribe(function (res) {
            _this.refNoList = res;
        });
    };
    DocumentIssueComponent.prototype.selectCustomerType = function (type) {
        this.selectedCustomerType = type;
        this.step = 1;
    };
    DocumentIssueComponent.prototype.selectDocumentType = function (type) {
        this.selectedDocumentType = type;
        this.step = 2;
        // if credit/debit then require replaced document
        if (type.type.endsWith('note')) {
            this.data.replaced = true;
        }
        // set purpose dropdown list
        this.setPurposeDropdown(type);
    };
    DocumentIssueComponent.prototype.selectBuyer = function (buyer, isReceivedFrom) {
        console.log(buyer);
        Object.assign(this.data.buyer, {
            address: buyer.address,
            // branchName: buyer.branch_name === 'HQ' ? '' : buyer.branch_name,
            // headOffice: buyer.branch_name === 'HQ',
            customerID: buyer.customer_id,
            branchCode: buyer.branch_code,
            country: buyer.country_code,
            postCode: buyer.post_code,
            email: buyer.email,
        });
        if (isReceivedFrom) {
            this.data.buyer.taxID = this.data.buyer.receivedFrom;
        }
        else {
            this.data.buyer.receivedFrom = this.data.buyer.taxID;
        }
    };
    DocumentIssueComponent.prototype.selectInvoice = function (buyer) {
        var _this = this;
        Object.assign(this.data.buyer, {
            address: buyer.buyer_address,
            branchName: buyer.buyer_branch_name === 'HQ' ? '' : buyer.branch_name,
            headOffice: buyer.buyer_branch_name === 'HQ',
            branchCode: buyer.buyer_branch_code.toString(),
            country: buyer.buyer_country_code,
            postCode: buyer.buyer_post_code,
            email: buyer.buyer_email,
            taxID: { tax_id: buyer.buyer_tax_id },
            receivedFrom: { name: buyer.buyer_name },
        });
        var oldAmount = buyer.total_items_line_total_amount_after_discount || buyer.total_items_line_total_amount;
        this.originalAmount = oldAmount;
        this.newAmount = oldAmount;
        _.forEach(buyer.tax_data_line_item, function (obj) {
            if (obj.product_id) {
                _this.data.items = [];
            }
        });
        if (!this.selectedDocumentType.type) {
            this.data.items = [{
                    po: null,
                    product_id: null,
                    description: '',
                    qty: '1',
                    unitPrice: '0.00',
                    discount: '0.00',
                    amount: 0,
                    rawAmount: 0,
                }];
        }
        else {
            buyer.tax_data_line_item.forEach(function (obj) {
                _this.data.items.push({
                    po: null,
                    product_id: obj.product_id,
                    description: obj.product_name,
                    qty: obj.quantity,
                    unitPrice: obj.unit_price,
                    discount: obj.discount_or_charge_per_piece,
                    rawAmount: obj.total_amount_per_piece,
                    amount: obj.net_total_amount
                });
            });
        }
    };
    DocumentIssueComponent.prototype.setPurposeDropdown = function (type) {
        this.purposes = PURPOSES[type.type].concat([
            { label: 'อื่น ๆ', value: 'other' } // be careful to change other's value (related to template, validation)
        ]);
    };
    DocumentIssueComponent.prototype.addItem = function (index) {
        this.data.items.splice(index + 1, 0, {
            po: null,
            product_id: null,
            description: '',
            qty: '1',
            unitPrice: '0.00',
            discount: '0.00',
            amount: 0,
            rawAmount: 0,
        });
    };
    DocumentIssueComponent.prototype.addRemark = function (index) {
        this.remarkCount.splice(index + 1, 0, index);
        this.data.remarks.messages.splice(index + 1, 0, null);
    };
    DocumentIssueComponent.prototype.updateAmount = function (index) {
        var data = this.data.items[index];
        data.rawAmount = Number(data.unitPrice) * Number(data.qty);
        data.amount = Number(data.unitPrice) * Number(data.qty) - Number(data.discount);
    };
    DocumentIssueComponent.prototype.removeItem = function (index) {
        this.data.items.splice(index, 1);
    };
    DocumentIssueComponent.prototype.removeRemark = function (index) {
        this.data.remarks.messages.splice(index, 1);
        this.remarkCount.splice(index, 1);
    };
    DocumentIssueComponent.prototype.validate = function () {
        var _this = this;
        this.resetError();
        this.errorTaxId = null;
        this.errors.items = null;
        this.errorRefDate = null;
        this.errorRefID = null;
        // document validation
        this.errors.document = validate(this.data, this.constraints.document);
        // buyer validation
        var buyerConstraints = validate.extend({}, this.constraints.buyer.general);
        if (this.isForeignCorporation) {
            validate.extend(buyerConstraints, this.constraints.buyer.foreign);
        }
        else {
            validate.extend(buyerConstraints, this.constraints.buyer.notForeign);
        }
        if (this.isDomesticCorporation) {
            validate.extend(buyerConstraints, this.constraints.buyer.domestic);
        }
        this.errors.buyer = validate(this.data.buyer, buyerConstraints);
        // items validation
        this.errors.items = this.data.items.map(function (obj) { return validate(obj, _this.constraints.item); });
        if (this.data.buyer.taxID) {
            if (this.data.buyer.taxID.length === 13) {
                this.errorTaxId = null;
            }
            else if ((typeof (this.data.buyer.taxID)) === 'object') {
                this.errorTaxId = null;
            }
            else {
                this.errorTaxId = 'Tax id must be 13 digits';
            }
        }
        // Ref Document validation
        if (this.data.referenceDocumentID && (this.selectedDocumentType.type === 'debit_note' || this.selectedDocumentType.type === 'credit_note')) {
            this.data.referenceDocumentID.map(function (obj) {
                _this.errorRefDate = obj.refDate ? null : 'Ref. Date can\'t be blank';
                _this.errorRefID = obj.refDocID ? null : 'Ref. ID can\'t be blank';
            });
        }
        return [
            this.errors.document,
            this.errors.buyer,
            this.errorTaxId,
            this.errorRefID,
            this.errorRefDate,
            !this.errors.items.every(function (obj) { return obj == null; })
        ].every(function (obj) { return !obj; });
    };
    DocumentIssueComponent.prototype.sign = function () {
        var _this = this;
        if (!this.validate() || this.duplicateDocumentNumber || !this.checkTwoNumberDocumentNumber()) {
            return;
        }
        this.errors.pdf = null;
        this.isLoading = true;
        this.step = 3;
        var payment_term_due_date_time;
        // if (this.selectedDocumentType.type == 'invoice') {
        //   payment_term_due_date_time = moment(this.data.due_date).format('YYYY-MM-DD') + 'T' + moment().format('HH:mm:ss');
        // } else {
        payment_term_due_date_time = '';
        // }
        var taxId = '';
        var received = this.data.buyer.receivedFrom.toString();
        if ((typeof (this.data.buyer.receivedFrom)) === 'object') {
            received = this.data.buyer.receivedFrom.name.toString();
        }
        if (this.data.buyer.taxID) {
            if ((typeof (this.data.buyer.taxID)) === 'object') {
                if (this.data.buyer.taxID.tax_id != null) {
                    taxId = this.data.buyer.taxID.tax_id.toString();
                }
                else {
                    taxId = null;
                }
            }
            else {
                taxId = this.data.buyer.taxID.toString();
            }
        }
        var data = {
            file_type: this.selectedDocumentType.type,
            invoice_number: this.data.documentNo,
            issue_dt: moment(this.data.date).format('YYYY-MM-DD') + 'T' + moment().format('HH:mm:ss'),
            // reference_document_id: this.data.referenceDocumentID,
            reference_document_id: this.data.referenceDocumentID.map(function (obj, index) {
                return ({
                    refDate: obj.refDate ? moment(obj.refDate).format('YYYY-MM-DD') + 'T' + moment().startOf('day').format('HH:mm:ss') : '',
                    refDocID: obj.refDocID,
                });
            }),
            purpose: this.data.purpose,
            buyer: {
                name: received,
                tax_id: taxId,
                branch_code: this.data.buyer.branchCode.toString(),
                branch_name: this.data.buyer.headOffice ? 'HQ' : this.data.buyer.branchName,
                address: this.data.buyer.address,
                post_code: this.data.buyer.postCode,
                country_code: this.data.buyer.country,
                customer_id: this.data.buyer.customerID ? this.data.buyer.customerID : '',
                buyer_type: this.selectedCustomerType.value,
                email: this.data.buyer.email,
                broker_name: this.data.buyer.brokerName,
                broker_email: this.data.buyer.brokerEmail,
                type_of_treaty: this.data.buyer.typeOfTreaty ? this.data.buyer.typeOfTreaty : '',
            },
            line_items: this.data.items.map(function (obj, index) { return ({
                item_number: String(index + 1),
                product_name: obj.description,
                quantity: obj.qty,
                unit_price: obj.unitPrice,
                net_discount_or_charge: obj.discount,
            }); }),
            total_items: {
                total: String(this.total),
                sub_total_before_vat: String(this.subTotal.toFixed(2)),
                percent_vat: this.data.vatType,
                vat: String((this.vat).toFixed(2)),
                total_payment: String((this.grandTotal).toFixed(2)),
                word_amount_th: String(this.grandTotalText),
                discount_or_charge: String(this.discountTotal),
                payment_term_due_date_time: payment_term_due_date_time,
            },
            payment_method: this.data.payment.type,
            payment_method_info: {},
            remarks: this.data.remarks,
        };
        // payment method info
        if (this.data.payment.type === 'cash') {
            data.payment_method_info = {
                description: this.data.payment.cashInfo
            };
        }
        else if (this.data.payment.type === 'bank_transfer') {
            data.payment_method_info = {
                description: this.data.payment.bankInfo
            };
        }
        else if (this.data.payment.type === 'cheque') {
            data.payment_method_info = {
                number: this.data.payment.chequeInfo,
                bank: this.data.payment.chequeBank
            };
        }
        else if (this.data.payment.type === 'credit_card') {
            data.payment_method_info = {
                number: this.data.payment.creditInfo,
                expire_date: this.data.payment.creditExpire
            };
        }
        if (this.data.purpose === 'other') {
            data['purpose'] = this.data.purpose === 'other' ? this.data.purposeText : this.data.purpose;
        }
        // replacement
        if (this.data.replaced) {
            data['purpose'] = this.data.purpose === 'other' ? this.data.purposeText : this.data.purpose;
            // data['reference_document_id'] = this.data.referenceDocumentID.header_invoice_number;
        }
        if (this.selectedDocumentType.type === 'receipt_tax_invoice') {
            // data['reference_document_id'] = this.data.referenceDocumentID.header_invoice_number;
        }
        else if (this.selectedDocumentType.type === 'debit_note' || this.selectedDocumentType.type === 'credit_note') {
            data.total_items['original_amount'] = this.originalAmount;
            data.total_items['original_vat'] = this.originalVat;
            data.total_items['difference_amount'] = this.subTotal.toFixed(2);
            data.total_items['new_amount'] = this.getNewAmount.toFixed(2);
        }
        this.apiService.createETaxInvoice(data).subscribe(function (res) {
            _this.result = {
                pdf: {
                    url: res.pdf_file,
                    httpHeaders: { Authorization: 'Bearer' + ' ' + localStorage.getItem('currentUser') },
                    withCredentials: true
                },
                email: res.buyer_email,
                id: res.tax_data_id,
                message: null
            };
            _this.isLoading = false;
            _this.sniff('CREATE_DOC', _this.rd_doc_types[_this.selectedDocumentType.type] + " - " + _this.data.documentNo);
        }, function (err) {
            // this.errors.pdf = err.error;
            var duplicate_branch_name = 'duplicate key value violates unique constraint';
            if (err.error.includes(duplicate_branch_name)) {
                _this.errors.pdf = 'Buyer Name already has Branch Name with another Branch Code';
            }
            else {
                _this.errors.pdf = err.error;
            }
            _this.isLoading = false;
        });
    };
    DocumentIssueComponent.prototype.print = function () {
        var _this = this;
        var httpOptions = {
            headers: this.result.pdf.httpHeaders,
            responseType: 'blob',
            withCredentials: this.result.pdf.withCredentials
        };
        this.http.get(this.result.pdf.url, httpOptions).subscribe(function (res) {
            var blobUrl = window.URL.createObjectURL(res);
            window.open(blobUrl, '_blank');
            _this.sniff('CLICK_PRINT', _this.rd_doc_types[_this.selectedDocumentType.type] + " - " + _this.data.documentNo);
        });
    };
    DocumentIssueComponent.prototype.openMailModal = function () {
        this.modal = this.modalService.open(this.modalContent);
        this.result.message = null;
    };
    DocumentIssueComponent.prototype.closeMailModal = function () {
        this.modal.close();
    };
    DocumentIssueComponent.prototype.sendMail = function () {
        var _this = this;
        // validate email
        this.data_buyer_each_email = this.data.buyer.email.split(', ');
        this.data_buyer_each_email.forEach(function (element) {
            validate.single(element, _this.constraints.email);
            if (_this.errors.email) {
                return;
            }
        });
        this.isSending = true;
        var data = {
            tax_data_id: this.result.id,
            email: this.data.buyer.email,
            broker_email: this.data.buyer.brokerEmail ? this.data.buyer.brokerEmail : '',
            action_log_address: 'DOC_ISSUE',
        };
        this.apiService.sendEmailETaxInvoice(data).subscribe(function (res) {
            _this.result.message = res.message;
            _this.isSending = false;
            _this.clickSentEmail = true;
        }, function (err) {
            _this.result.message = err.error;
            _this.isSending = false;
            _this.clickSentEmail = false;
        });
    };
    DocumentIssueComponent.prototype.resetData = function () {
        this.data = {
            buyer: {
                receivedFrom: null,
                branchName: '',
                headOffice: false,
                address: '',
                postCode: '',
                country: null,
                taxID: null,
                branchCode: null,
                email: null,
                customerID: null,
                brokerName: null,
                brokerEmail: null,
                typeOfTreaty: null,
            },
            date: new Date(),
            due_date: null,
            documentNo: '',
            companyReferenceDocument: '',
            replaced: false,
            purpose: null,
            purposeText: null,
            referenceDocumentID: [{
                    refDocID: '',
                    refDate: ''
                }],
            items: [{
                    po: null,
                    product_id: null,
                    description: '',
                    qty: '1',
                    unitPrice: '0.00',
                    discount: '0.00',
                    amount: 0,
                    rawAmount: 0,
                }],
            vatType: '7',
            payment: {
                type: 'cash',
                cashInfo: '',
                bankInfo: '',
                chequeInfo: '',
                chequeBank: '',
                creditInfo: '',
                creditExpire: ''
            },
            remarks: {
                messages: [null],
            },
        };
        this.result = {
            pdf: null,
            email: null,
            id: null,
            message: null
        };
        this.originalAmount = 0;
        this.originalVat = 0;
    };
    DocumentIssueComponent.prototype.setMinDate = function () {
        var disabledTime = new Date();
        disabledTime.setDate(1);
        this.minimumDate = disabledTime;
    };
    DocumentIssueComponent.prototype.resetError = function () {
        this.errors = {
            document: null,
            buyer: null,
            items: [],
            pdf: null,
            email: null,
        };
    };
    DocumentIssueComponent.prototype.resetAll = function () {
        this.step = 1;
        this.isLoading = false;
        this.selectedDocumentType = null;
        this.selectedCustomerType = this.customerTypes[0];
        this.resetData();
        this.resetError();
    };
    DocumentIssueComponent.prototype.checkDocumentNumber = function () {
        var _this = this;
        var params = {
            invoice_number: this.data.documentNo
        };
        this.apiService.checkMatchedInvoiceNumber(params).subscribe(function (res) {
            _this.duplicateDocumentNumber = res.duplicate;
            if (_this.duplicateDocumentNumber) {
                _this.duplicateDocumentNumberText = 'Duplicate Document Number';
            }
            else {
                _this.duplicateDocumentNumberText = null;
            }
        });
    };
    DocumentIssueComponent.prototype.checkTwoNumberDocumentNumber = function () {
        this.twoNumberDocumentNumber = this.data.documentNo;
        if (this.twoNumberDocumentNumber.length === 0 || this.twoNumberDocumentNumber.length > 2) {
            this.twoNumberDocumentNumberText = null;
        }
        else {
            this.twoNumberDocumentNumberText = 'Document Number can not be 2 digits';
        }
        return this.twoNumberDocumentNumber.length > 2;
    };
    DocumentIssueComponent.prototype.addRefID = function () {
        this.data.referenceDocumentID.push({
            refDocID: '',
            refDate: ''
        });
    };
    DocumentIssueComponent.prototype.removeRefID = function (index) {
        this.data.referenceDocumentID.splice(index, 1);
    };
    DocumentIssueComponent.prototype.completeBrokerList = function (event) {
        var _this = this;
        var query = event.query;
        var params = {
            broker_name: query
        };
        this.apiService.getBuyer(params).subscribe(function (res) {
            _this.brokerNameList = res;
        });
    };
    DocumentIssueComponent.prototype.selectBroker = function (buyer) {
        Object.assign(this.data.buyer, {
            brokerEmail: buyer.broker_email
        });
    };
    DocumentIssueComponent.prototype.editData = function () {
        this.step = 2;
        this.isLoading = false;
    };
    DocumentIssueComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'DOC_ISSUE',
            target: target
        };
        this.apiService.sniff(data).subscribe();
    };
    return DocumentIssueComponent;
}());
export { DocumentIssueComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/document-issue.component.ts.pre-build-optimizer.js